/*
 * CMBR – einheitliche Produktgrößen in Bildkacheln
 * ------------------------------------------------
 * Misst auf jedem Produktfoto (Freisteller auf weißem/transparentem Grund), wo das Kleidungsstück sitzt,
 * und skaliert es so, dass es genauso viel Fläche einnimmt wie das Referenzprodukt:
 *   - Shirts  -> wie "Band Tour T-Shirt Acid Black"
 *   - Rest    -> wie "Chateau Hoodie Patroit Blue"
 * Fotos mit Hintergrund (Model-/Lifestyle-Bilder) bleiben unverändert.
 *
 * Konfiguration kommt aus window.CMBR_FIT:
 *   { selector, refs: { hoodie: url, shirt: url }, refTileRatio: 4/3 }
 */
(function () {
  var cfg = window.CMBR_FIT;
  if (!cfg || !cfg.selector || cfg.__running) return;
  cfg.__running = true;

  var SAMPLE_WIDTH = 160;
  var refTileRatio = cfg.refTileRatio || 4 / 3; // Kachel, in der die Referenzen "richtig" aussehen (Kollektion 3:4)
  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem('cmbrFit:v1') || '{}'); } catch (e) {}

  function persist() {
    try { sessionStorage.setItem('cmbrFit:v1', JSON.stringify(cache)); } catch (e) {}
  }

  function keyFor(url) {
    try {
      var u = new URL(url, location.href);
      return u.pathname + '?v=' + (u.searchParams.get('v') || '');
    } catch (e) {
      return url;
    }
  }

  function sampleUrl(url) {
    var u = new URL(url, location.href);
    u.searchParams.set('width', String(SAMPLE_WIDTH));
    u.searchParams.delete('height');
    u.searchParams.delete('crop');
    return u.toString();
  }

  /* Liefert die Bounding-Box des Kleidungsstücks (0..1 relativ zum Bild) oder 0, wenn das Bild nicht passt */
  var pending = {};
  function analyze(url, cb) {
    var key = keyFor(url);
    if (key in cache) return cb(cache[key]);
    if (pending[key]) return pending[key].push(cb);
    pending[key] = [cb];

    function done(result) {
      if (result !== null) {
        cache[key] = result;
        persist();
      }
      var list = pending[key] || [];
      delete pending[key];
      list.forEach(function (fn) { fn(result); });
    }

    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.decoding = 'async';
    img.onerror = function () { done(null); };
    img.onload = function () {
      try {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) return done(null);
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0);
        var d = ctx.getImageData(0, 0, w, h).data;

        function at(x, y) {
          var k = (y * w + x) * 4;
          return [d[k], d[k + 1], d[k + 2], d[k + 3]];
        }

        var corners = [at(1, 1), at(w - 2, 1), at(1, h - 2), at(w - 2, h - 2)];
        var bg = [0, 0, 0, 0];
        corners.forEach(function (p) { for (var n = 0; n < 4; n++) bg[n] += p[n] / 4; });

        var transparent = bg[3] < 20;
        var uniform = corners.every(function (p) {
          if (transparent) return p[3] < 20;
          return p[3] > 200 && Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]) < 24;
        });
        var light = transparent || (bg[0] + bg[1] + bg[2]) / 3 > 200;

        // Kein Freisteller (z. B. Model-Foto) -> nicht anfassen
        if (!uniform || !light) return done(0);

        var x0 = w, y0 = h, x1 = -1, y1 = -1;
        for (var y = 0; y < h; y++) {
          for (var x = 0; x < w; x++) {
            var k = (y * w + x) * 4;
            var fg;
            if (transparent) {
              fg = d[k + 3] > 40;
            } else {
              fg = d[k + 3] > 40 && (Math.abs(d[k] - bg[0]) + Math.abs(d[k + 1] - bg[1]) + Math.abs(d[k + 2] - bg[2])) > 36;
            }
            if (fg) {
              if (x < x0) x0 = x;
              if (x > x1) x1 = x;
              if (y < y0) y0 = y;
              if (y > y1) y1 = y;
            }
          }
        }

        if (x1 < 0) return done(0);

        var box = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, a: w / h };

        // Motiv füllt praktisch das ganze Bild -> nichts zu normalisieren
        if (box.x1 - box.x0 > 0.97 && box.y1 - box.y0 > 0.97) return done(0);

        done(box);
      } catch (e) {
        done(null); // z. B. Canvas durch Fremd-Domain gesperrt -> Bild bleibt wie es ist
      }
    };
    img.src = sampleUrl(url);
  }

  /* Größe des Motivs in einer Kachel mit "contain" – gemessen in Kachelbreiten */
  function containedSize(box, tileRatio) {
    var imgWidth = Math.min(1, tileRatio * box.a); // dargestellte Bildbreite in Kachelbreiten
    return {
      w: imgWidth * (box.x1 - box.x0),
      h: imgWidth * (box.y1 - box.y0) / box.a
    };
  }

  /* Zielrahmen je Referenz (in Kachelbreiten) */
  var targets = {};
  var refsReady = false;
  var waiting = [];

  function loadRefs() {
    var names = Object.keys(cfg.refs || {});
    var left = names.length;
    if (!left) { refsReady = true; return; }

    names.forEach(function (name) {
      analyze(cfg.refs[name], function (box) {
        if (box) targets[name] = containedSize(box, refTileRatio);
        if (--left === 0) {
          refsReady = true;
          waiting.splice(0).forEach(function (fn) { fn(); });
        }
      });
    });
  }

  function whenRefsReady(fn) {
    if (refsReady) fn(); else waiting.push(fn);
  }

  function targetFor(container) {
    var holder = container.closest('[data-cmbr-type]');
    var type = ((holder ? holder.getAttribute('data-cmbr-type') : cfg.productType) || '').toLowerCase();
    if ((type.indexOf('shirt') !== -1 || type.indexOf('tee') !== -1) && targets.shirt) return targets.shirt;
    return targets.hoodie || targets.shirt || null;
  }

  function place(container, img, box) {
    var target = targetFor(container);
    var cw = container.clientWidth, ch = container.clientHeight;
    if (!target || !cw || !ch) return false;

    var bw = box.x1 - box.x0;
    var bh = (box.y1 - box.y0) / box.a;      // Motivhöhe in Bildbreiten
    var s = Math.min(target.w / bw, target.h / bh); // Bildbreite in Kachelbreiten

    var cx = (box.x0 + box.x1) / 2;           // Motivmitte in Bildbreiten
    var cy = (box.y0 + box.y1) / 2 / box.a;
    var ratio = ch / cw;                       // Kachelhöhe in Kachelbreiten

    var left = 0.5 - cx * s;
    var top = ratio / 2 - cy * s;

    img.style.setProperty('position', 'absolute', 'important');
    img.style.setProperty('inset', 'auto', 'important');
    img.style.setProperty('max-width', 'none', 'important');
    img.style.setProperty('max-height', 'none', 'important');
    img.style.setProperty('aspect-ratio', 'auto', 'important');
    img.style.setProperty('object-fit', 'fill', 'important');
    img.style.setProperty('height', 'auto', 'important');
    img.style.setProperty('width', (s * 100).toFixed(3) + '%', 'important');
    img.style.setProperty('left', (left * 100).toFixed(3) + '%', 'important');
    img.style.setProperty('top', (top / ratio * 100).toFixed(3) + '%', 'important');
    return true;
  }

  function processContainer(container) {
    if (container.__cmbrFit) return;
    container.__cmbrFit = true;

    var imgs = Array.prototype.slice.call(container.querySelectorAll('img'));
    if (!imgs.length) return;

    container.setAttribute('data-cmbr-fit', 'pending');
    var left = imgs.length;
    var reveal = function () {
      if (--left <= 0) container.setAttribute('data-cmbr-fit', 'done');
    };
    // Sicherheitsnetz: nie länger als 2,5 s unsichtbar
    setTimeout(function () { container.setAttribute('data-cmbr-fit', 'done'); }, 2500);

    imgs.forEach(function (img) {
      var url = img.currentSrc || img.src || (img.getAttribute('srcset') || '').split(' ')[0];
      if (!url) return reveal();

      analyze(url, function (box) {
        if (!box) return reveal();
        whenRefsReady(function () {
          place(container, img, box);
          reveal();
        });
      });
    });
  }

  function scan(root) {
    var list = (root || document).querySelectorAll(cfg.selector);
    for (var i = 0; i < list.length; i++) processContainer(list[i]);
  }

  loadRefs();
  scan();

  // Neue Karten (Sortieren, Filtern, Nachladen) automatisch mitnehmen
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length) { scan(); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
